




















































































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import BasicTextEditor from '@front-app/components/inputs/BasicTextEditor.vue';
import BaseEditor from '../BaseEditor.vue';
import {
	HighlightsImageComponent,
	HighlightsImageRatio,
	HighlightsImageSize,
	HIGHLIGHTS_IMAGE_RATIOS,
} from '../../model';
import { useHighlightsInput } from '../../hooks/useHighlightsInput';

const SIZE_LABELS: Record<HighlightsImageSize, string> = {
	[HighlightsImageSize.BANNER_MEDIUM]: 'Medium Banner (16x4)',
	[HighlightsImageSize.BANNER_LARGE]: 'Large Banner (16x9)',
};

const SIZE_OPTIONS: SelectBoxChoice[] = [
	{
		key: HighlightsImageSize.BANNER_MEDIUM,
		label: SIZE_LABELS[HighlightsImageSize.BANNER_MEDIUM],
	},
	{
		key: HighlightsImageSize.BANNER_LARGE,
		label: SIZE_LABELS[HighlightsImageSize.BANNER_LARGE],
	},
];

export default defineComponent({
	components: {
		BaseEditor,
		FormLabel,
		FormInput,
		FormError,
		BasicTextEditor,
		SelectBox,
		HelpTooltipBlock,
		FormSection,
	},
	props: {
		value: {
			type: Object as PropType<HighlightsImageComponent>,
			required: true,
		},
	},
	setup(props, ctx) {
		const useInput = useHighlightsInput(ctx, computed(() => props.value));
		const currentSize = computed(() => {
			const result = Object.entries(HIGHLIGHTS_IMAGE_RATIOS)
				.find(([, val]) => compareRatios(props.value.meta, val));
			return result ? result[0] : HighlightsImageSize.BANNER_MEDIUM;
		});
		const updateSize = (newVal: HighlightsImageSize) => {
			useInput.doMetaInput(HIGHLIGHTS_IMAGE_RATIOS[newVal]);
		};

		// validation
		const validation = v({
			altText: {
				value: computed(() => props.value.meta.altText),
				rules: [required()],
			},
			src: {
				value: computed(() => props.value.meta.src),
				rules: [required()],
			},
		});
		// End validation
		return {
			updateSize,
			currentSize,
			SIZE_LABELS,
			SIZE_OPTIONS,
			DropdownPosition,
			doInput: useInput.doInput,
			doMetaInput: useInput.doMetaInput,
			validation,
		};
	},
});

function compareRatios(a: HighlightsImageRatio, b: HighlightsImageRatio) {
	return a.ratioWidth === b.ratioWidth && a.ratioHeight === b.ratioHeight;
}
